export const scheduleLoanFieldsMapping = {
  CONTRACT_NUMBER: 'contractNo',
  DUE_DATE: 'paymentDueDate',
  AMOUNT: 'installmentAmount',
  REMAINING_BALANCE: 'outstandingBalance',
  VAT: 'vatAmount',
  VAT_AMOUNT: 'vatAmount',
  NET_RENTAL: 'installmentAmount',
  NET_RENTAL_OL: 'installmentAmount',
  MAINTENANCE: 'maintenanceFees',
  GROSS_RENTAL: 'grossRental',
};

export const tableBoldKeys = ['CONTRACT_NUMBER', 'AMOUNT', 'GROSS_RENTAL'];
export const dateFormatKeys = ['DUE_DATE'];
export const amountFormatKeys = [
  'AMOUNT',
  'REMAINING_BALANCE',
  'VAT_AMOUNT',
  'VAT',
  'NET_RENTAL',
  'NET_RENTAL_OL',
  'MAINTENANCE',
  'GROSS_RENTAL',
];
